var _g, _rect, _g2, _g3, _g4, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDgCl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_279",
    "data-name": "Group 279",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.75,
    height: 29.629,
    viewBox: "0 0 15.75 29.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M153.691,545.884l-.056-28.279c0-.614-.664-1.111-1.481-1.11l-11.483.023c-.817,0-1.478.5-1.477,1.116l.056,28.279Z",
    transform: "translate(-138.598 -516.495)",
    fill: "#bfc6d8",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(0.957 2.501)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 13.727,
    height: 24.209,
    transform: "translate(0 0.027) rotate(-0.113)",
    fill: "#a2aaba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(2.207 3.442)",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 11.233,
    height: 22.332,
    rx: 0.441,
    transform: "translate(0 0.022) rotate(-0.113)",
    fill: "#9ea6b7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(0.644 26.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M153.686,543.2h0a44.9,44.9,0,0,1-14.444.029Z",
    transform: "translate(-139.242 -543.204)",
    fill: "#9ea6b7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(0.596 1.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M153.638,518.968h0a46.338,46.338,0,0,0-14.444.028Z",
    transform: "translate(-139.194 -518.416)",
    fill: "#959ead"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(0 28.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M139.428,545.286l14.082-.027c.46,0,.832.278.833.624l-15.745.031C138.6,545.568,138.969,545.287,139.428,545.286Z",
    transform: "translate(-138.598 -545.259)",
    fill: "#9ea6b7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(0 29.388)",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 15.749,
    height: 0.21,
    transform: "translate(0 0.031) rotate(-0.113)",
    fill: "#959ead"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M141.3,520.14l10.218-.02a.322.322,0,0,1,.322.322l.042,21.3a.322.322,0,0,1-.32.323l-10.218.02a.323.323,0,0,1-.323-.321l-.042-21.306A.323.323,0,0,1,141.3,520.14Z",
    transform: "translate(-138.598 -516.495)",
    fill: "#ebedf2",
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgCl);
export default __webpack_public_path__ + "static/media/dg-cl.bdd5453e41977e71f46ca633c87664a3.svg";
export { ForwardRef as ReactComponent };